'use client';

import { FC } from 'react';

import Image from '@/components/core/Image';
import { useTranslation } from '@/hooks/useTranslations';
import pokiImg3 from '@/public/assets/Images/poki 3.png';

import './styles.scss';

const WhatWeDoBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="whatWeDoWrapper" id="what-we-do">
      <div className="whatWeDoShadowHolder" />
      <div className="whatWeDoInfo">
        <h1 className="whatWeDoTitle">{t('Aboutus-H1')}</h1>
        <p className="whatWeDoTxt">{t('Aboutus-Desc')}</p>
      </div>
      <div className="whatWeDoImgWrp">
        <Image className="whatWeDoImg" src={pokiImg3} alt="" />
      </div>
    </div>
  );
};

export default WhatWeDoBanner;
